import { LogicalFieldMixin } from './mixins.js';

const LogicalLocation = {
  mixins: [LogicalFieldMixin],

  template: `
    <div class="form-field-input">
      <button class="btn-default" disabled>
        <span>点击定位</span>
        <i class="slp-map-marker"></i>
      </button>
    </div>
  `
};

export default LogicalLocation;
